module.exports = __webpack_public_path__ + "img/3.8659bc14.png";